import React from "react";

const Unknown = () => {
  return (
    <svg
      fill="none"
      height="20"
      viewBox="0 0 12 20"
      width="12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.98993 2.57V0H4.98993V2.55C2.86993 2.83 1.22993 4.22 1.01993 6.03C0.819926 7.72 1.95993 9.9 5.72993 10.96C7.47993 11.45 8.63993 12.16 9.00993 12.96C9.23993 13.45 9.11993 13.91 8.97993 14.21C8.60993 15.01 7.08993 15.72 4.59993 15.41C2.66993 15.17 1.37993 14.02 0.999926 13.64V16.16C2.97993 17.41 4.61993 17.41 4.98993 17.43V20H6.98993V17.38C8.80993 17.12 10.2099 16.3 10.7899 15.05C11.2399 14.09 11.2499 13.05 10.8199 12.12C10.1899 10.74 8.64993 9.7 6.26993 9.03C4.12993 8.43 2.87993 7.36 3.00993 6.25C3.09993 5.44 4.03993 4.55 5.57993 4.48C8.44993 4.37 10.4299 6.21 10.4999 6.28V3.82C9.64993 3.31 8.44993 2.76 6.98993 2.57Z"
        fill="#95928E"
      />
    </svg>
  );
};

export default Unknown;
